CalendarSettingsView = require 'views/power-ups/calendar-settings-view'
CardAgingSettingsView = require 'views/power-ups/card-aging-settings-view'
LegacyPowerUps = require 'data/legacy-power-ups'
VotingSettingsView = require 'views/power-ups/voting-settings-view'

module.exports = [
  name: 'voting'
  settingsView: (model) -> new VotingSettingsView({ model })
  id: LegacyPowerUps.voting
,
  name: 'cardAging'
  settingsView: (model) -> new CardAgingSettingsView({ model })
  id: LegacyPowerUps.cardAging
,
  name: 'calendar'
  settingsView: (model) -> new CalendarSettingsView({ model })
  id: LegacyPowerUps.calendar
]



// WEBPACK FOOTER //
// ./app/scripts/views/directory/directory-legacy-power-ups.coffee